<template>
  <div class="container">
    <div class="container-header">
      <div class="swiper-box">
        <img :src="slide1" />
        <!-- <swiper :options="swiperOptions">
        <swiper-slide v-for="(item, idx) in sliderList" :key="idx">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper> -->
      </div>
      <div class="main-menu">
        <div class="menu-item" :class="[index == 1 ? 'active' : '']" v-for="(item, index) in bnts" :key="index"
          @click="onLink(item)">
          <div class="item-bg">
            <img :src="item.img" alt="" />
          </div>
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="content-item">
        <div>
          <h4>通知公告</h4>
          <div class="box2">
            <div class="list-item" v-for="(item, index) in articleList1.slice(0, 8)" :key="item.id">
              <div class="first" v-if="index == 0">
                <img v-lazy="item.articleCoverUrl" alt="" class="news-img" @click="onArticleDeatil(item)"
                  v-if="articleList1.length > 0" />
                <div class="first-title">{{ item.articleTitle }}</div>
              </div>
              <div class="news-item" v-else @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="more" @click="onMore('通知公告', 107)">更多 ></p>
          <div class="box2">
            <div class="list-item" v-for="item in articleList1.slice(8, 20)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--右侧菜单-->
        <div>
          <h4>智慧医疗</h4>
          <div class="box1">
            <div v-for="(item, index) in bnts1" :key="item.name" :class="[`bgColor${index}`, 'btn-item']"
              @click="onLink(item)">
              <img :src="item.img" alt="" />
              <span> {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="content-item">
        <div>
          <h4>医保专区</h4>
          <div class="box2">
            <div class="list-item" v-for="(item, index) in articleList2.slice(0, 6)" :key="item.id">
              <div class="first" v-if="index == 0">
                <img v-lazy="item.articleCoverUrl" alt="" class="news-img" @click="onArticleDeatil(item)"
                  v-if="articleList2.length > 0" />
                <div class="first-title">{{ item.articleTitle }}</div>
              </div>
              <div class="news-item" v-else @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-center">
          <div class="box2">
            <div class="list-item" v-for="item in articleList2.slice(6, 16)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="more" @click="onMore('医保专区', 108)">更多 ></p>
          <div class="box2">
            <div class="list-item" v-for="item in articleList2.slice(16, 26)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-item">
        <div>
          <h4>医疗动态</h4>
          <div class="box2">
            <div class="list-item" v-for="(item, index) in articleList3.slice(0, 6)" :key="item.id">
              <div class="first" v-if="index == 0">
                <img v-lazy="item.articleCoverUrl" alt="" class="news-img" @click="onArticleDeatil(item)"
                  v-if="articleList3.length > 0" />
                <div class="first-title">{{ item.articleTitle }}</div>
              </div>
              <div class="news-item" v-else @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-center">
          <div class="box2">
            <div class="list-item" v-for="item in articleList3.slice(6, 16)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="more" @click="onMore('医疗动态', 109)">更多 ></p>
          <div class="box2">
            <div class="list-item" v-for="item in articleList3.slice(16, 26)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-item">
        <div>
          <h4>体检通知</h4>
          <div class="box2">
            <div class="list-item" v-for="(item, index) in articleList4.slice(0, 6)" :key="item.id">
              <div class="first" v-if="index == 0">
                <img v-lazy="item.articleCoverUrl" alt="" class="news-img" @click="onArticleDeatil(item)"
                  v-if="articleList4.length > 0" />
                <div class="first-title">{{ item.articleTitle }}</div>
              </div>
              <div class="news-item" v-else @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-center">
          <div class="box2">
            <div class="list-item" v-for="item in articleList4.slice(6, 16)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="more" @click="onMore('体检通知', 110)">更多 ></p>
          <div class="box2">
            <div class="list-item" v-for="item in articleList4.slice(16, 26)" :key="item.id">
              <div class="news-item" @click="onArticleDeatil(item)">
                <span>{{ item.articleTitle }}</span>
                <span>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="public-service">
        <h4>公共卫生服务</h4>
        <div class="service">
          <div class="doc">
            <img :src="u16" alt="" />
          </div>
          <div class="service-right">
            <h3>公共卫生服务</h3>
            <h5>
              国家基本公共卫生服务项目,是促进基本公共卫生服务逐步均等化的重要内容,是深化医药卫生体制改革的重要工作
            </h5>
            <div
              class="service-item"
              v-for="item in serviceList"
              :key="item.name"
              @click="onService(item)"
            >
              <img :src="item.img" alt="" />
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { uuid } from "@/utils";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import slide1 from "@/assets/img/header_pre.jpg";
import { mapGetters, mapMutations } from "vuex";
import { queryCategory, getList } from "@/api/article";
import { getHealthDataListNew2 } from "@/api/report";
import icon1 from "@/assets/img/icon_1.png";
import icon2 from "@/assets/img/icon_2.png";
import icon3 from "@/assets/img/icon_3.png";
import icon4 from "@/assets/img/icon_4.png";
import iconHome2 from "@/assets/img/icon_home2.png";
import icon_service from "@/assets/img/icon_service.png";
import icon5 from "@/assets/img/icon_5.png";
import icon6 from "@/assets/img/icon_6.png";
import icon7 from "@/assets/img/icon_7.png";
import icon8 from "@/assets/img/icon_8.png";
import icon9 from "@/assets/img/icon_9.png";
import icon10 from "@/assets/img/icon_10.png";
import icon11 from "@/assets/img/icon_11.png";
import icon12 from "@/assets/img/icon_12.png";
import icon13 from "@/assets/img/icon_13.png";
import u16 from "@/assets/img/doc.png";
import { encrypt } from "@/utils/encrypt";
import base from "@/assets/base/base.js";
export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      slide1,
      u16,
      bnts: [
        {
          name: "预约挂号",
          path: "/onlineRegistrationV2",
          img: icon11,
        },
        {
          name: "检验检查报告",
          path: "/report",
          img: icon10,
        },
        {
          name: "体检预约",
          path: "/medicalBooking",
          img: icon7,
        },
      ],
      bnts1: [
        {
          name: "药品查询",
          path: "/drugQuery",
          img: icon12,
        },
        {
          name: "体检报告",
          path: "/medicalReport",
          img: icon6,
        },
        {
          name: "检后咨询",
          path: "/chat",
          img: icon4,
        },
        {
          name: "申请休假",
          path: "/sick-leave-list",
          img: icon13,
        },
        // {
        //   name: "心理咨询",
        //   path: "/psychologicalCounseling",
        //   img: iconHome2,
        // },
        {
          name: "体检数据对比分析",
          path: "/healthTable",
          img: icon_service,
        },
      ],
      serviceList: [
        {
          name: "疫情动态发布",
          img: icon9,
          herf:
            "https://voice.baidu.com/act/newpneumonia/newpneumonia/?from=osari_aladin_banner",
        },
        {
          name: "核酸检测",
          img: icon3,
          herf:
            "https://map.baidu.com/mobile/webapp/search/search/qt=con&wd=%E6%A0%B8%E9%85%B8%E6%A3%80%E6%B5%8B%E6%9C%BA%E6%9E%84&c=179&provider=pc-aladin&pn=0&device_ratio=1&da_src=shareurl&",
        },
        {
          name: "疫苗接种",
          img: icon8,
          herf:
            "https://map.baidu.com/mobile/webapp/search/search/qt=s&wd=%E6%96%B0%E5%86%A0%E7%96%AB%E8%8B%97%E6%8E%A5%E7%A7%8D%E5%9C%B0%E5%9B%BE&c=179&searchFlag=bigBox&version=5&exptype=dep&src_from=webapp_all_bigbox&sug_forward=&src=1/vt=",
        },
        {
          id: 103,
          name: "隔离管控",
          img: icon2,
        },
        {
          id: 104,
          name: "传染病管理",
          img: icon1,
        },
        {
          id: 105,
          name: "食品安全",
          img: icon5,
        },
      ],
      sliderList: [{ id: 1, img: slide1 }],
      swiperOptions: {
        autoplay: false,
        loop: false,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      articleList1: [], //通知公告
      articleList2: [], //医保专区
      articleList3: [], //医疗动态
      articleList4: [], //体检通知
    };
  },
  created() {
    /**获取新闻资讯 */
    this.getArticleList1(107);
    this.getArticleList2(108);
    this.getArticleList3(109);
    this.getArticleList4(110);
    this.getSliderList();
    // this.getArticleType()
    sessionStorage.setItem("isBW", true);
  },
  mounted() {
    if (sessionStorage.getItem("userInfo")) {
      this.getAbnormalData();
    }
  },
  computed: {
    ...mapGetters({
      layoutTitle: "layout/lyaoutTitle",
    }),
  },
  methods: {
    /*获取异常体检弹窗*/
    async getAbnormalData() {
      let { idCard, passport } = JSON.parse(sessionStorage.getItem("userInfo"));
      let requestData = {
        certificateNo: idCard ? idCard : passport, //证件号
        isAbnormal: 1, //是否异常 0-正常全部展示 1-只展示异常
      };

      const { data, code } = await getHealthDataListNew2(requestData);

      if (code == 200) {
        //需要提示
        if (data) {
          let { needRemind, columnList } = data;
          if (needRemind && columnList.length > 0) {
            let physicalExamNo = columnList[0].physicalExamNo;
            let summaryDate = columnList[0].summaryDate;
            let that = this;
            this.$confirm({
              title: "温馨提示",
              content: `您在${summaryDate}的体检报告内容有异常项，是否查看`,
              onOk() {
                that.$router.push({ path: "/medicalReport", query: { physicalExamNo } });
              },
              onCancel() { },
            });
          }
        }
      }
    },
    async getSliderList() {
      const params = {
        data: {},
        page: 3,
        pageSize: 1,
      };
      const { data, code } = await getList(params);
      if (code == 200) {
        this.sliderList = data.reverse();
      }
    },
    //获取通知公告
    async getArticleList1(articleTypeId) {
      const params = {
        data: {
          articleTypeId,
        },
        page: 1,
        pageSize: 26,
      };
      const { data, code } = await getList(params);
      if (code == 200) {
        this.articleList1 = data;
      }
    },
    //获取医保专区
    async getArticleList2(articleTypeId) {
      const params = {
        data: {
          articleTypeId,
        },
        page: 1,
        pageSize: 26,
      };
      const { data, code } = await getList(params);
      if (code == 200) {
        this.articleList2 = data;
      }
    },
    //获取医疗动态
    async getArticleList3(articleTypeId) {
      const params = {
        data: {
          articleTypeId,
        },
        page: 1,
        pageSize: 26,
      };
      const { data, code } = await getList(params);
      if (code == 200) {
        this.articleList3 = data;
      }
    },
    //获取体检通知
    async getArticleList4(articleTypeId) {
      const params = {
        data: {
          articleTypeId,
        },
        page: 1,
        pageSize: 26,
      };
      const { data, code } = await getList(params);
      if (code == 200) {
        this.articleList4 = data;
      }
    },
    //文章类型
    async getArticleType() {
      const { data, code } = await queryCategory();
      // console.log(data, code)
    },
    ...mapMutations({
      setLayoutTitle: "layout/setLayoutTitle",
    }),
    onArticleDeatil(data) {
      if (data.isOuterChain == 0) {
        //外链
        window.open(data.articleContent);
      } else {
        this.$router.push({
          path: "/articleDetail",
          query: {
            articleId: data.id,
          },
        });
      }
    },
    onLink(data) {
      if (!sessionStorage.getItem("userInfo")) {
        let id = uuid();
        let url = data.path ? data.path.split('/')[1] : 'index';
        console.log(url)
        console.log(id)
        window.open(
          `https://zjuam.zju.edu.cn/cas/oauth2.0/authorize?response_type=code&client_id=U2ZEp4RHRJTgzgy5Pq&redirect_uri=https://xyszyl.zju.edu.cn/medical/auth/codeRedirect&state=${id}_PC_${url
          }`,
          "_self"
        );
        return;
      }
      if (data.path) {
        this.$router.push({ path: data.path });
      }
    },
    onMore(articleType, id) {
      this.$router.push({ path: "/articleList", query: { typeId: id } });
      this.setLayoutTitle(articleType);
    },
    onService(data) {
      if (data.id) {
        this.$router.push({ path: "/articleList", query: { typeId: data.id } });
      }
      if (data.herf) {
        window.open(data.herf, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 0;
  max-width: 100%;

  .container-header {
    position: relative;
    height: 784px;

    .swiper-box {
      height: 660px;

      img {
        width: 100%;
        height: 660px;
        background-color: #fff;
        // cursor: pointer;
      }

      .swiper-container {
        width: 1280px;
        height: 320px;

        img {
          width: 100%;
          height: 320px;
          // cursor: pointer;
        }
      }
    }

    .main-menu {
      position: absolute;
      bottom: 0;
      z-index: 3;
      width: 1200px;
      margin-left: -600px;
      left: 50%;

      .menu-item {
        position: relative;
        display: inline-block;
        cursor: pointer;
        width: 400px;
        height: 216px;
        padding: 10px;
        box-sizing: border-box;
        background: linear-gradient(90deg, #fa987d 0%, #fc7c58 100%);
        box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);

        .item-bg {
          width: 100%;
          height: 126px;
          line-height: 126px;
          text-align: center;
          background: rgba(0, 0, 0, 0.05);
        }

        .title {
          margin: 20px 0;
          font-size: 22px;
          font-weight: 600;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
        }
      }

      .menu-item:nth-child(2) {
        background: linear-gradient(90deg, #82b0ff 0%, #3e83f9 100%);
        box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
      }

      .menu-item:nth-child(3) {
        background: linear-gradient(90deg, #b3a1ff 0%, #9278ff 100%);
        box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
      }

      .active {
        z-index: 3;
        transform: scale(1.15);
      }
    }
  }

  .content {
    max-width: 1200px;
    margin: 40px auto;

    .content-item {
      // height: 462px;
      overflow: hidden;
    }

    h4 {
      position: relative;
      height: 33px;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      line-height: 33px;
      margin-bottom: 30px;
    }

    h4::after {
      position: absolute;
      bottom: -10px;
      left: 0;
      content: "";
      width: 96px;
      height: 6px;
      background: #3f86ff;
    }

    &-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;

      .box1 {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .btn-item {
          cursor: pointer;
          border-width: 0px;
          width: 100%;
          height: 90px;
          margin-bottom: 10px;
          box-sizing: border-box;
          border-radius: 4px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          background: #f8f8f8;

          img {
            width: 60px;
            height: 60px;
            margin: 0 20px;
          }

          span {
            // width: 88px;
            height: 30px;
            font-size: 19px;
            font-weight: 600;
            color: #333333;
            line-height: 30px;
          }
        }

        .bgColor-0 {
          background: linear-gradient(90deg, #82b0ff 0%, #3e83f9 100%);
          box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
        }

        .bgColor-1 {
          background: linear-gradient(90deg, #38efb4 0%, #0ace8f 100%);
          box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
        }

        .bgColor-2 {
          background: linear-gradient(90deg, #ffd48a 0%, #fbc24a 100%);
          box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
        }
      }

      .box2 {
        .news-img {
          position: absolute;
          width: 340px;
          height: 205px;
          background-color: rgba(246, 246, 246, 1);
          box-sizing: border-box;
          -moz-box-shadow: none;
          -webkit-box-shadow: none;
          box-shadow: none;
          font-family: "Helvetica ", "Helvetica", sans-serif;
          font-style: normal;
        }

        .list-item {
          margin-bottom: 8px;
          cursor: pointer;
        }

        .first {
          position: relative;
          height: 205px;
          width: 340px;
        }

        .first-title {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 3;
          color: #fff;
          font-size: 14px;
          width: 340px;
          padding: 10px;
          box-sizing: border-box;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          background-color: rgba($color: #333, $alpha: 0.5);
        }

        .news-item {
          width: 340px;
          display: flex;
          padding: 0 10px;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          color: #333;

          span {
            font-size: 14px;

            &:nth-child(1) {
              flex: 3;
              font-weight: 400;
              line-height: 32px;
              font-weight: 400;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            &:nth-child(2) {
              flex: 2;
              text-align: right;
              color: #999999;
            }
          }
        }

        .news-item:hover {
          color: #1890ff;
        }
      }

      .list-center {
        padding-top: 75px;
      }

      .more {
        text-align: right;
        margin-bottom: 44px;
        font-size: 20px;
        cursor: pointer;
        color: #999;

        &:hover {
          color: #5e7ed4;
        }
      }

      >div {
        &:nth-child(1) {
          flex: 5;
        }

        &:nth-child(2) {
          flex: 5;
          margin-right: 42px;
        }

        &:nth-child(3) {
          flex: 4;
        }
      }
    }

    .public-service {
      padding-bottom: 80px;

      h4::after {
        width: 144px;
      }

      .service {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        height: 546px;
        background: #f8f8f8;

        .doc {
          padding: 105px 0 0 90px;
          width: 553px;
          height: 440px;

          img {
            height: 440px;
          }
        }

        .service-right {
          flex: 1;
          padding: 40px;
          box-sizing: border-box;

          h3 {
            height: 40px;
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
          }

          h5 {
            height: 56px;
            font-size: 20px;
            font-weight: 400;
            color: #999999;
            line-height: 28px;
            margin-bottom: 40px;
          }
        }

        .service-item {
          display: inline-block;
        }

        &-item {
          margin-bottom: 40px;
          width: 140px;
          height: 110px;
          box-sizing: border-box;
          font-size: 16px;
          cursor: pointer;
          text-align: center;

          div {
            margin-top: 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
          }

          img {
            width: 60px;
            height: 60px;
          }
        }
      }
    }
  }
}
</style>
